module.exports = __webpack_public_path__ + "img/blueforward.09534539.svg";